// extracted by mini-css-extract-plugin
export default {"container":"entity_container__lUnM5"};